import { useContext, useCallback, useMemo } from "react";
import { VersionedDataContext } from "../../../contexts/versioned_data/context";
import { LockForecastButtonComponent } from "./component";
import { useCustomer } from "../../../contexts/app/provider";
import { LockForecastContext } from "../../../contexts/lock_forecast";

export const LockForecastButtonContainer = () => {
  const { mainRun, lastSuccessfulRun } = useContext(VersionedDataContext);
  const { customerSettings } = useCustomer();
  const { lockForecast, unlockForecast, isLockUnlockLoading } =
    useContext(LockForecastContext);

  // Get the run to use (mainRun or lastSuccessfulRun as fallback)
  const runToUse = mainRun || lastSuccessfulRun;

  // Check if the current run is the one that locked the forecast
  const isLocked = useMemo(() => {
    if (!runToUse || !customerSettings) {
      return false;
    }

    const forecastLockedToRunId = customerSettings.forecastLockedToRunId;
    if (!forecastLockedToRunId) {
      return false;
    }

    // Check if the current run's settings match the locked run settings
    return JSON.stringify(runToUse.runSettings) === forecastLockedToRunId;
  }, [runToUse, customerSettings]);

  const handleToggleLock = useCallback(async () => {
    console.log("[LockForecastButtonContainer] handleToggleLock called", {
      isLocked,
      isLockUnlockLoading,
      hasRunToUse: !!runToUse,
      runId: runToUse?.id,
      runSettings: runToUse?.runSettings,
      timestamp: new Date().toISOString(),
    });

    if (isLockUnlockLoading || !runToUse) {
      console.log("[LockForecastButtonContainer] handleToggleLock aborted", {
        reason: isLockUnlockLoading ? "loading" : "no run",
        timestamp: new Date().toISOString(),
      });
      return;
    }

    if (isLocked) {
      console.log("[LockForecastButtonContainer] Unlocking forecast...");
      await unlockForecast();
    } else {
      console.log("[LockForecastButtonContainer] Locking forecast...", {
        inputId: runToUse.runSettings.inputId,
        settingsNameAndVersion: runToUse.runSettings.settingsNameAndVersion,
      });
      await lockForecast(
        runToUse.runSettings.inputId,
        runToUse.runSettings.settingsNameAndVersion,
        JSON.stringify(runToUse.runSettings)
      );
    }
  }, [isLocked, runToUse, lockForecast, unlockForecast, isLockUnlockLoading]);

  return (
    <LockForecastButtonComponent
      mainRun={runToUse}
      isLocked={isLocked}
      onToggleLock={handleToggleLock}
      loading={isLockUnlockLoading}
    />
  );
};
